// extracted by mini-css-extract-plugin
module.exports = {"button":"StartButton__button--OAIXI","activeButton":"StartButton__activeButton--2JJdX"};